import { memo, useEffect, useState } from "react";
import { deepEquals } from "../util";
import ReactTimeago from "react-timeago";
import { fetchRunArgs } from "../api";

export const ArgumentHistory = memo((props) => {
    const { changes, renderExtra = null, runId } = props;

    const [expanded, setExpanded] = useState(null);

    return <div className="argument-history">
        {changes.map(change => <ArgumentChange
            key={change.timestamp}
            data={change}
            runId={runId}
            renderExtra={renderExtra}
            expand={() => setExpanded(v => v === change.step ? null : change.step)}
            expanded={change.step === expanded}
        />)}
    </div>;
}, deepEquals);


const ArgumentChange = (props) => {
    const { data, renderExtra, expand, expanded, runId } = props;

    const { timestamp, old: oldArgs, "new": newArgs, modified_keys, step = -1 } = data;


    return (
        <div className="argument-history-item">
            {modified_keys.map(key => {
                const oldVal = stringify(oldArgs[key]);
                const newVal = stringify(newArgs[key]);

                const extra = renderExtra && renderExtra(key, oldArgs, newArgs);

                return (
                    <div key={key} className="modified">
                        <span className="changed-arg-step" onClick={expand}>#{step}</span>

                        <span className="changed-arg">{key}</span> changed from <span className="changed-arg">{oldVal}</span> to <span className="changed-arg">{newVal}</span>.

                        <span className="change-timer">
                            <ReactTimeago date={timestamp} />

                            {extra && <span className="extra">{extra}</span>}
                        </span>
                    </div>
                )
            })}

            {expanded && <ChangeComparison runId={runId} step={step} compareTo={newArgs} />}
        </div>
    )
}


const ChangeComparison = (props) => {
    const { runId, step, compareTo } = props;

    const [currentArgs, setCurrentArgs] = useState(null);
    useEffect(() => {
        fetchRunArgs(runId).then(setCurrentArgs);
    }, [runId]);

    const differences = getArgumentDiff(compareTo, currentArgs);

    return (
        <div className="argument-delta">
            Difference with current args:

            <div className="argument-delta-list">
                <table>
                    <thead>
                        <tr>
                            <th>Param</th>
                            <th>#{step}</th>
                            <th>Current</th>
                        </tr>
                    </thead>

                    <tbody>
                        {differences.map(diff => (
                            <tr>
                                <td><b>{diff.param}</b></td>
                                <td><span className="changed-arg" style={{ whiteSpace: 'pre' }}>{JSON.stringify(diff.prev)}</span></td>
                                <td><span className="changed-arg" style={{ whiteSpace: 'pre' }}>{JSON.stringify(diff.current)}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

function getArgumentDiff(prev, current) {
    if (!prev || !current) {
        return [];
    }

    const changes = [];
    const allKeys = new Set([...Object.keys(prev), ...Object.keys(current)]);

    for (const k of allKeys) {
        if (prev[k] !== current[k]) {
            changes.push({
                param: k,
                prev: prev[k],
                current: current[k],
            });
        }
    }

    return changes;
}

function stringify(value) {
    if (typeof value === 'undefined') {
        return "<nonexistant>";
    } else if (value === null) {
        return "<null>";
    } else if (value === true) {
        return "<true>";
    } else if (value === false) {
        return "<false>";
    } else {
        return value.toString();
    }
}
